<template>
  <div>
    <v-text-field v-if="field.type === 'text'" v-model="translatedValue" :hint="hintText" placeholder="Add translation" class="fs-exclude" outlined dense block single-line>
      <template #append>
        <v-icon color="primary" :disabled="!translatedValue || !translatedValue.length">
          check_circle
        </v-icon>
      </template>
    </v-text-field>
    <template v-if="field.type === 'date'">
      <v-menu
        v-model="showDateModal"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
        class="fs-exclude"
        offset-x
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            label="Add translation"
            outlined
            :error="isInvalidDate"
            class="fs-exclude"
            append-icon="event"
            :hint="errorMessage || hintText"
            single-line
            dense
            v-bind="attrs"
            v-on="on"
            @click:append="showDateModal = true"
            @keyup.enter="showDateModal = false"
            @input="saveDate($event)"
          >
            <template #append>
              <v-icon color="primary" :disabled="isInvalidFormat">
                check_circle
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker
          v-model="rawValue"
          no-title
          class="fs-exclude"
          @input="saveDate($event)"
        />
      </v-menu>
    </template>
  </div>
</template>

<script>
import { prettyDate } from '@/domains/global/functions/util'
import moment from 'moment'
export default {
  props: {
    field: { type: Object, required: true },
    lastDateValue: { type: String, default: null }
  },
  data() {
    return {
      rawValue: null,
      translatedValue: null,
      showDateModal: false,
      date: null,
      errorMessage: '',
      isInvalidDate: false
    }
  },
  computed: {
    hintText() {
      return this.field.exampleText ? `Example: ${this.field.exampleText}` : null
    },
    isInvalidFormat() {
      if (this.field.type === 'date') {
        const { isValid } = this.isValidAndConvertDate(this.date)
        return this.isInvalidDate || !isValid
      }
      return false
    }
  },
  watch: {
    field: {
      deep: true,
      handler() {
        this.translatedValue = this.field.translatedValue
        this.rawValue = this.field.rawValue
      }
    },
    translatedValue: {
      deep: true,
      handler() {
        this.$emit('input', { translatedValue: this.translatedValue, rawValue: this.rawValue })
      }
    },
    lastDateValue: {
      handler() {
        if (this.field.type === 'date' && this.lastDateValue && !this.field.rawValue) {
          this.rawValue = this.lastDateValue
        }
      }
    }
  },
  mounted() {
    this.translatedValue = this.field.translatedValue
    this.rawValue = this.field.rawValue
  },
  methods: {
    isValidAndConvertDate(date) {
      const supportedFormats = ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', 'D/M/YY', 'D/M/YYYY']

      for (const format of supportedFormats) {
        const momentDate = moment(date, format, true)
        if (momentDate.isValid()) {
          return {
            isValid: true,
            convertedDate: momentDate.format('YYYY-MM-DD')
          }
        }
      }

      return {
        isValid: false,
        convertedDate: null
      }
    },
    saveDate(date) {
      const { isValid, convertedDate } = this.isValidAndConvertDate(date)

      if (!date === '' || !isValid) {
        this.isInvalidDate = true
        this.errorMessage = 'Invalid date format.'
        return
      }

      this.isInvalidDate = false
      this.errorMessage = ''
      this.rawValue = convertedDate

      this.translatedValue = prettyDate(this.rawValue)
      this.showDateModal = false
      this.$emit('setLastDate', this.rawValue)
    },
    savePickerDate(date) {
      this.date = moment(date).format('DD/MM/YYYY')
      this.saveDate(this.date)
    }
  }
}
</script>
